<template>
  <div class="product-listing-compare">
    <button 
      class="product-listing-compare-btn btn btn-link text-black my-3"
      id="compare-button"
      data-bs-toggle="offcanvas"
      data-bs-target="#compare-drawer"
      aria-controls="compare-drawer"
    >
      <slot name="compare-button-title"></slot>
    </button>
  </div>
</template>
<script>
export default {
}
</script>